function initHasuHeroScroll() {
  document.querySelectorAll('[data-hasu-hero-scroll]').forEach((button) => {
    if (button.dataset.hasuHeroBound) return;
    button.dataset.hasuHeroBound = 'true';
 
    button.addEventListener('click', () => {
      const section = button.closest('.hasu-hero-section');
      const next = section ? section.nextElementSibling : null;
      if (next) {
        next.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
}
 
document.addEventListener('DOMContentLoaded', initHasuHeroScroll);
document.addEventListener('shopify:section:load', initHasuHeroScroll);
 